import PropTypes from 'prop-types';
import './Header.scss';

export const Header = ({
  text, size = '', position = '', fontSize = '', extraStyle = '',
}) => (<h3 className={`header header--${size} header--${position} header--${fontSize} ${extraStyle}`}>{text}</h3>);

Header.propTypes = {
  text: PropTypes.string.isRequired,
  size: PropTypes.string,
  position: PropTypes.string,
  fontSize: PropTypes.string,
  extraStyle: PropTypes.string,
};
